import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { Driver, driverSchema } from '../schemas/driver.schema';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Creates Drivers
 * @param drivers The Drivers being created
 * @returns Data Object containing the created Drivers
 */
export function postDrivers(this: unknown, drivers: Partial<Driver>[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).driversUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(drivers),
      })
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(driverSchema),
      })
    )
  );
}
